import Moment from 'moment';
import { extendMoment } from 'moment-range';
import * as d3 from 'd3';
import template from './heatCalendar.html';
import './heatCalendar.css';

const moment = extendMoment(Moment);

function drawCalendar(year, month, selectedDate) {}

function heatCalendar($document, $element) {
    var controller = [
        '$scope',
        '$timeout',
        '$q',
        'DS',
        function($scope, $timeout, $q, DS) {
            $scope.selectedDate = moment($scope.date);
            $scope.currentDate = moment($scope.date);
            $scope.komentari = [];
            // debugger;

            const months = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

            $scope.months = months.map(m => {
                return moment([$scope.currentDate.year(), m]);
            });

            $scope.drawCalendar = () => {
                let date = moment([$scope.currentDate.year(), $scope.currentDate.month(), 1]);

                let start = date.format('YYYY-MM-DD');
                let end = date
                    .add(1, 'months')
                    .add(-1, 'days')
                    .format('YYYY-MM-DD');

                let range = moment.range(start, end);
                const data = Array.from(range.by('day')).map(r => {
                    return { date: r };
                });

                if (_.isObject($scope.heatData)) {
                    data.map(d => {
                        d.heatIndex = $scope.heatData[d.date.format('YYYY-MM-DD')];
                    });
                }

                $scope.draw(data);
            };

            $scope.changeMonth = m => {
                $scope.currentDate.month(m.month());
                $scope.onChange({ year: $scope.currentDate.year(), month: $scope.currentDate.month() });
                $scope.drawCalendar();
            };

            $scope.changeYear = y => {
                const year = $scope.currentDate.year() + y;
                $scope.currentDate.year(year);
                $scope.onChange({ year: $scope.currentDate.year(), month: $scope.currentDate.month() });
                $scope.drawCalendar();
            };

            $scope.onSelectDate = d => {
                $timeout(() => {
                    $scope.selectedDate = moment(d.date);
                    $scope.drawCalendar();
                    $scope.onDateSelected({ value: moment(d.date) });
                });
            };
        }
    ];

    return {
        restrict: 'E',
        scope: {
            date: '<',
            heatData: '<',
            onDateSelected: '&',
            onChange: '&'
        },
        templateUrl: template,
        controller: controller,
        link: function(scope, iElement, attrs) {
            let d = d3;
            let m = moment;
            let rootElement = iElement[0];

            let svg = d3.select('#calendar').append('svg');

            svg.attr('width', '100%');
            svg.attr('height', '100%');
            svg.attr('viewBox', '0 0 350 150');

            const isSelectedDate = d => {
                if (
                    d.year() === scope.selectedDate.year() &&
                    d.month() === scope.selectedDate.month() &&
                    d.date() === scope.selectedDate.date()
                ) {
                    return true;
                }
                return false;
            };

            scope.draw = data => {
                let startColor = d3.rgb('#ffffff');
                let endColor = d3.rgb('#a30010');
                let length = 10;
                let color = d3
                    .scaleLinear()
                    .domain([0, length])
                    .range([startColor, endColor]);

                svg.selectAll('g').remove();

                let margin = { top: 49, right: 20, bottom: 20, left: 19 },
                    cellWidth = 50,
                    cellHeight = 25;

                const day = d3.timeFormat('%w'),
                    week = d3.timeFormat('%U'),
                    percent = d3.format('.1%'),
                    format = d3.timeFormat('%d'),
                    monthName = d3.timeFormat('%B');

                const days = svg.selectAll('g').data(data);

                const dayGroups = days
                    .enter()
                    .append('g')
                    .attr('transform', (d, i) => {
                        const startOfMonth = moment([d.date.year(), d.date.month(), 1]);
                        const x = day(d.date) * cellWidth;
                        const y = (week(d.date) - week(startOfMonth)) * cellHeight + cellHeight;
                        return `translate(${x}, ${y})`;
                    })
                    .attr('class', d => {
                        if (isSelectedDate(d.date)) {
                            return 'selected';
                        }
                    });

                dayGroups
                    .append('rect')
                    .attr('width', cellWidth)
                    .attr('height', cellHeight)
                    .attr('fill', d => {
                        return color(d.heatIndex || 0);
                    });

                const circle = svg
                    .select('.selected')
                    .append('circle')
                    .attr('r', cellHeight / 2 - 1)
                    .attr('cx', cellWidth / 2)
                    .attr('cy', cellHeight / 2);

                dayGroups
                    .append('text')
                    .text(function(d, i) {
                        return d.date.format('DD');
                    })
                    .attr('text-anchor', 'middle')
                    .attr('class', 'num-dates')
                    .attr('x', cellWidth / 2)
                    .attr('y', (cellHeight + 10) / 2)
                    .on('click', d => {
                        scope.onSelectDate(d);
                    });

                const labels = svg
                    .append('g')
                    .selectAll('text')
                    .data(['NED', 'PON', 'UTO', 'SRI', 'ČET', 'PET', 'SUB'])
                    .enter()
                    .append('text')
                    .text(function(d, i) {
                        return d;
                    })
                    .attr('x', (d, i) => (i + 0.5) * cellWidth)
                    .attr('y', cellHeight / 2)
                    .attr('text-anchor', 'middle')
                    .attr('class', 'days');
            };

            scope.$watch('heatData', (newVal, oldVal) => {
                scope.drawCalendar();
            });
        }
    };
}

heatCalendar.$inject = ['$document', '$timeout'];

export { heatCalendar };



// WEBPACK FOOTER //
// ./app/components/dashboard/heatCalendar.directive.js